import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-5" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:items-center justify-between gap-4 pb-4 border-b border-divider" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2 mb-1" }
const _hoisted_4 = { class: "text-[11px] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full bg-beige text-active" }
const _hoisted_5 = { class: "text-xs text-muted" }
const _hoisted_6 = { class: "text-xl sm:text-2xl font-bold text-brown" }
const _hoisted_7 = { class: "text-sm sm:text-base font-normal text-muted font-caudex" }
const _hoisted_8 = { class: "text-xs text-alternative-gray mt-1" }
const _hoisted_9 = { class: "flex items-center gap-2 self-start lg:self-center" }
const _hoisted_10 = { class: "text-xs text-muted hidden sm:inline" }
const _hoisted_11 = { class: "flex bg-secondary p-1 rounded-xl border border-divider text-xs" }
const _hoisted_12 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-4" }
const _hoisted_13 = { class: "p-3 sm:p-4 rounded-xl border border-gold/40 bg-[#FFFDF9] hover:shadow-md transition-all cursor-pointer flex items-center gap-2.5 sm:gap-3.5" }
const _hoisted_14 = { class: "w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gold/15 text-gold flex items-center justify-center font-bold text-base sm:text-xl shrink-0" }
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = { class: "text-[10px] sm:text-xs font-bold uppercase tracking-wider text-[#9A6E1E] truncate" }
const _hoisted_17 = { class: "text-xs sm:text-sm font-bold text-brown truncate" }
const _hoisted_18 = { class: "text-[10px] text-muted hidden sm:block" }
const _hoisted_19 = { class: "p-3 sm:p-4 rounded-xl border border-success/30 bg-[#F6FAF7] hover:shadow-md transition-all cursor-pointer flex items-center gap-2.5 sm:gap-3.5" }
const _hoisted_20 = { class: "w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-success/15 text-success flex items-center justify-center font-bold text-base sm:text-xl shrink-0" }
const _hoisted_21 = { class: "min-w-0" }
const _hoisted_22 = { class: "text-[10px] sm:text-xs font-bold uppercase tracking-wider text-success truncate" }
const _hoisted_23 = { class: "text-xs sm:text-sm font-bold text-brown truncate" }
const _hoisted_24 = { class: "text-[10px] text-muted hidden sm:block" }
const _hoisted_25 = { class: "p-3 sm:p-4 rounded-xl border border-divider bg-secondary/70 hover:shadow-md transition-all cursor-pointer flex items-center gap-2.5 sm:gap-3.5" }
const _hoisted_26 = { class: "w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white text-brown border border-divider flex items-center justify-center font-bold text-base sm:text-xl shrink-0" }
const _hoisted_27 = { class: "min-w-0" }
const _hoisted_28 = { class: "text-[10px] sm:text-xs font-bold uppercase tracking-wider text-alternative-gray truncate" }
const _hoisted_29 = { class: "text-xs sm:text-sm font-bold text-brown truncate" }
const _hoisted_30 = { class: "text-[10px] text-muted hidden sm:block" }
const _hoisted_31 = { class: "p-3 sm:p-4 rounded-xl border border-error/30 bg-[#FDF7F7] hover:shadow-md transition-all cursor-pointer flex items-center gap-2.5 sm:gap-3.5" }
const _hoisted_32 = { class: "w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-error/15 text-error flex items-center justify-center font-bold text-base sm:text-xl shrink-0" }
const _hoisted_33 = { class: "min-w-0" }
const _hoisted_34 = { class: "text-[10px] sm:text-xs font-bold uppercase tracking-wider text-error truncate" }
const _hoisted_35 = { class: "text-xs sm:text-sm font-bold text-brown truncate" }
const _hoisted_36 = { class: "text-[10px] text-muted hidden sm:block" }

import { computed } from "vue";
import { BestDaysCount } from "@/types/calculators";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BestDaysByCategoryComponent',
  props: {
    startDay: {},
    endDay: {},
    bestDaysCount: {},
    dayStem: {},
    yearPillar: {},
    isCalendarView: { type: Boolean }
  },
  emits: ["showAsCalendar"],
  setup(__props: any) {

const props = __props;


const { t } = useI18n();

const periodString = computed(() => {
  // 1. Переворачиваем даты в DD.MM.YYYY
  const start = props.startDay.split("-").reverse().join(".");
  const end = props.endDay.split("-").reverse().join(".");

  // 2. Считаем чистую разницу в днях
  const days =
    (Date.parse(props.endDay) - Date.parse(props.startDay)) / 86400000 + 1;

  // 3. Собираем строку, отдавая склонение на откуп i18n
  return `${start} — ${end} (${t("labels.days_period", days)})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.badge")), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(periodString.value), 1)
        ]),
        _createElementVNode("h2", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.best-days-card.title")) + " ", 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.diapason-params", {
                yearPillar: __props.yearPillar,
                dayStem: __props.dayStem,
              })), 1)
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.desc")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.view-toggle")), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: _normalizeClass(["font-bold shadow-sm px-3 py-1.5 rounded-lg transition-colors", 
              __props.isCalendarView
                ? 'bg-white text-brown'
                : 'text-muted hover:text-brown'
            ]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showAsCalendar', true)))
          }, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.calendar")), 3),
          _createElementVNode("button", {
            class: _normalizeClass(["px-3 py-1.5 rounded-lg transition-colors", 
              __props.isCalendarView
                ? 'text-muted hover:text-brown'
                : 'bg-white text-brown'
            ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showAsCalendar', false)))
          }, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.table")), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, " ★" + _toDisplayString(__props.bestDaysCount.golden_days), 1),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.golden-days")), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.perfect-dates")), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.tong-shu")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, " ✓" + _toDisplayString(__props.bestDaysCount.favorable_days), 1),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.favourable")), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.great-for-tasks")), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.target-starts")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, _toDisplayString(__props.bestDaysCount.personal_clash_days), 1),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.for-routine")), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.current-tasks")), 1),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)(
                "calculators.personal-date.best-days-card.with-no-important-starts"
              )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, " ✕" + _toDisplayString(__props.bestDaysCount.general_taboo_days), 1),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.breakout")), 1),
          _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.card-conflict")), 1),
          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)("calculators.personal-date.best-days-card.avoid-starting")), 1)
        ])
      ])
    ])
  ]))
}
}

})